const RegionNameLabel = Object.freeze({
  europe: 'Gamification_GameRegionSelectDialog_Region_Europe',
  africa: 'Gamification_GameRegionSelectDialog_Region_Africa',
  asia: 'Gamification_GameRegionSelectDialog_Region_Asia',
  'middle-east': 'Gamification_GameRegionSelectDialog_Region_MiddleEast',
  'north-america': 'Gamification_GameRegionSelectDialog_Region_NorthAmerica',
  'south-america': 'Gamification_GameRegionSelectDialog_Region_SouthAmerica',
  oceania: 'Gamification_GameRegionSelectDialog_Region_Oceania'
})

export { RegionNameLabel }



// WEBPACK FOOTER //
// ./src/modules/gamification/enum/RegionNameEnum.js